
// Re-export notification utilities
export {
  buildCompactImportMessage,
  createProcessingNotification,
  createCompletionNotification,
  createErrorNotification,
  createSignificantErrorNotification
} from './notifications'

// Re-export file guard functions from dedicated module
export {
  shouldSkipFile,
  isMarkdownFile,
  isAttachmentFile,
  detectCalendarFromFilename,
  isBinaryContent
} from './fileGuards'

// Re-export shared types from dedicated module
export type {
  ImportStats,
  ImportError,
  ImportWarning,
  ImportHint,
  ImportResult,
  ImportConflictChoice,
  ImportConflictDialogProps,
  ImportNote,
  ImportItem,
  ImportBatch,
  ImportBatchResult,
  FolderIdMap,
  MarkdownImportOptions,
  NoteProcessingOptions
} from './types'

// Re-export attachment strategy types
export type {
  AttachmentStrategy,
  AttachmentUploadResult,
  AttachmentUploadFailure,
  StrategyHooks
} from './attachmentStrategies'

/**
 * Specifies the source type of imported files
 * - 'craft': Craft app markdown export
 * - 'obsidian': Obsidian vault
 * - 'markdown': Generic markdown files
 * - 'bear': Bear app export
 * - 'auto': Auto-detect source type based on file structure
 */
export type ImportSourceType = 'craft' | 'obsidian' | 'markdown' | 'bear' | 'auto'

// Import types for internal use
import type { ImportStats } from './types'

/**
 * Core note processing utilities extracted from useImportFolder
 * These functions are framework-agnostic and can be reused across different import hooks
 */









/**
 * Creates an empty ImportStats object
 * 
 * @returns New ImportStats object with all counts set to 0
 */
export function createEmptyImportStats(): ImportStats {
  return {
    created: 0,
    skipped: 0,
    errors: 0,
    duplicated: 0,
    overwritten: 0,
    foldersCreated: 0,
    foldersReused: 0,
  }
}



/**
 * Merges two ImportStats objects by adding their corresponding fields
 *
 * @param a - First ImportStats object
 * @param b - Second ImportStats object
 * @returns New ImportStats object with combined values
 */
export function mergeStats(a: ImportStats, b: ImportStats): ImportStats {
  return {
    created: a.created + b.created,
    skipped: a.skipped + b.skipped,
    errors: a.errors + b.errors,
    duplicated: a.duplicated + b.duplicated,
    overwritten: a.overwritten + b.overwritten,
    foldersCreated: a.foldersCreated + b.foldersCreated,
    foldersReused: a.foldersReused + b.foldersReused,
  }
}






